import "./SignupCM.css";
import { showNotificationToast, toastify } from "../../../../helpers/toast/toastify";
import { useNavigate } from "react-router-dom";
import CogIcons from "../../../../assets/images/Setting.gif";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import React, { useEffect, useState } from "react";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import {
  globalAllLeaderCommunities,
  globalCommunity,
  globalCurrentPageTitle,
} from "../../../../store/globalstore";
import { useAtom } from "jotai";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { useDispatch, useSelector } from "react-redux";
import { fetchUser } from "../../../../helpers/helper";
import { setUserEmail, storeUser } from "../../../../redux/users/usersSlice";
import { setLoading } from "../../../../redux/loading/loadingSlice";
import {
  clearMultiCommunityState,
  setCurrentCommunity,
  setRefetchMultiCommunityList,
  setRefetchPage,
} from "../../../../redux/multicommunity/multicommunity";

const VerifyEmail = () => {
  const [communityFromStore,setCommunityInStore] = useAtom(globalCommunity);
  const [isVerified, setIsVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const api = useApi();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const email = useSelector((state) => state?.user?.userMail);

  const [, setAllLeaderCommunities] = useAtom(
    globalAllLeaderCommunities
  );


  const [, setCurrentPageTitle] = useAtom(
    globalCurrentPageTitle
  );
  
  const leaderCommunityList = async (user) => {
          const response = await api("get", "multiCommunity/leaderCommunityList");
          const leaderAllCommunities = response?.data || [];
          setAllLeaderCommunities(leaderAllCommunities);
      
          dispatch(setCurrentCommunity(leaderAllCommunities.find((community) => community.leader === user?.selectedCommunityId)))
          dispatch(setRefetchMultiCommunityList(false));
          dispatch(setRefetchPage(""));
        };
  if (!email) {
    navigate("/login");
  }
  const handleVerify = async () => {
    if (!otp || otp.length < 6) return toastify("Invalid code", "error");

    // setIsVerified(true);
    dispatch(setLoading(true));
    try {
      const response = await api("post", "/auth/verifyEmailOtp", {
        otp,
        email,
      });
      if (response?.status) {
        dispatch(clearMultiCommunityState());
        localStorage.clear();
        setUserEmail("");
        setCommunityInStore(null);
        localStorage.setItem("token", response?.data?.token);
        setCurrentPageTitle("Dashboard");
        if(response?.data?.user?.role=== "leader" && response?.data?.user?.selectedCommunityId){
          // dispatch(setRefetchSpecificUser(true));
          await leaderCommunityList(response?.data?.user);  
          const responseSpecificUser = await api("post", "multiCommunity/getSpecificUser", {
            id: response?.data?.user?.selectedCommunityId,
          });
      
          localStorage.setItem("token", responseSpecificUser?.data?.token);
          dispatch(storeUser(responseSpecificUser?.data));
        }else{
          await fetchUser(api, dispatch, storeUser);
        }
        // dispatch(storeUser(response?.data));
        
        setTimeout(async() => {
        if (response?.data?.user?.role === "memberNoLink") {
          navigate(`/cmWithNoLink/dashboard`);
          setIsVerified(false);
          // dispatch(setLoading(false));
          return;
        } else {
          // if (response?.data?.user?.role === "leader") {
          //   await leaderCommunityList(response?.data?.user);
          // }
          
          navigate(`/${response?.data?.user?.role}/dashboard`);
          if(response?.data?.todayMembersCount>0){
            showNotificationToast(`${response?.data?.todayMembersCount} new subscribers today! 🚀`, "");
          }
          setIsVerified(false);
          // dispatch(setLoading(false));
          return;
        }
        }, 1500);
      } else {
        // setTimeout(() => {
          dispatch(setLoading(false));
          // navigate("/login/newVerisfyEmail");
          // setIsVerified(false);
          toastify(response?.message, "error");
        // }, 1500);
      }
    } catch (error) {
      console.error("🚀 -> handleVerify -> error:", error);
      toastify(error?.response?.data?.message, "error");
    }
  };

  const sendOtp = async () => {
    try {
      const response = await api("post", "auth/updateAccountOTP",{
        email:email
      });

      if (response?.status) toastify(response?.message);
      else toastify(response?.message, "error");
    } catch (error) {
      console.error("🚀 -> sendOtp -> error:", error);
    }
  };

  useEffect(() => {
    if (otp?.length === 6) handleVerify();
  }, [otp]);

  return (
    <>
      {isVerified ? (
        <div className="onboardinLayout cmSide">
          <div className="onboardingCard verifyLoader">
            <div className="onboardingCardTopBox">
              <p className="businessName">
                {communityFromStore?.disPlayName?.toUpperCase()}
              </p>
            </div>
            <div className="onboardingCardContentBox cmSide">
              <div className="headingBox p-0 mb62px">
                <h2 className="title">Alright, let's get you started</h2>
                <p className="subText mx-auto">
                  Now you just need to connect and subscribe
                </p>
              </div>
              <div className="soloIconBox">
                <img alt="" src={CogIcons} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="onboardinLayout cmSide">
          <div className="onboardingCard">
            <div className="onboardingCardTopBox">
              <p className="businessName">
                {communityFromStore?.disPlayName?.toUpperCase()}
              </p>
            </div>
            <div className="onboardingCardContentBox cmSide">
              <div className="headingBox p-0 mb50px">
                <h2 className="title mb8px">Verify email</h2>
                <p className="subText ">
                Please use the code sent to your email.
                </p>
              </div>
              <div className="inputBox">
                <FloatingTextFiled
                  className="onboardingInput"
                  forLabel="Enter code from email"
                  label="Enter code from email"
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter code from email"
                  value={otp}
                />
              </div>

              <BubbleSvgButton
                onClick={handleVerify}
                text={`Next`}
                type="button"
                variant="black"
                containerStyling={{
                  justifyContent: "center",
                }}
              />

              <div className="text-center">
                <button className="resendBtn" onClick={sendOtp} type="button">
                  Resend Code
                </button>
              </div>
            </div>
            {/* {<div className="paginationDots">
              <button className="dot active"></button>
              <button className="dot"></button>
              <button className="dot"></button>
              <button className="dot"></button>
              <button className="dot"></button>
              <button className="dot"></button>
              <button className="dot"></button>
            </div>} */}
          </div>
        </div>
      )}
    </>
  );
};

export default VerifyEmail;
